import type { CSSProperties } from 'react'
import { type TypographyVariantsOptions } from '@mui/material'
import {
  newsreaderFont,
  robotoFont,
} from '@/components/providers/ThemeProvider/fonts'
import { colors } from './colors'

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true
    label1: true
  }
}

// Registered on the typography interfaces too (not just the `variant` prop) so
// `theme.typography.body3` is type-safe inside an sx callback.
declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: CSSProperties
    label1: CSSProperties
  }
  interface TypographyVariantsOptions {
    body3?: CSSProperties
    label1?: CSSProperties
  }
}

// See REDESIGN_TOKENS.md before changing values; some are load-bearing.
export const typography: TypographyVariantsOptions = {
  fontFamily: robotoFont.style.fontFamily,
  h1: {
    fontSize: '2.5rem',
    fontFamily: newsreaderFont.style.fontFamily,
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.875rem',
    fontWeight: 600,
  },
  h3: {
    fontSize: '1.625rem',
    fontWeight: 600,
  },
  h4: {
    fontSize: '1.375rem',
    fontWeight: 600,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  h6: {
    fontSize: '1.125rem',
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  body1: {
    fontSize: '1rem',
  },
  body2: {
    fontSize: '0.875rem',
  },
  body3: {
    fontSize: '0.6875rem',
  },
  label1: {
    fontSize: '0.6875rem',
    textTransform: 'uppercase' as const,
    color: colors.redesignNeutral.label,
    letterSpacing: '1.1px',
    fontWeight: 600,
  },
  button: {
    textTransform: 'none' as const,
  },
}
